<script setup>
import {onMounted, onUnmounted, reactive, ref} from "vue";
import MonitorHeader from "../MonitorHeader.vue";
import {Line} from 'vue-chartjs'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
} from 'chart.js'
import {useMonitorStore} from "../../../store/monitoring.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
)

const chart_data = reactive({
    labels: null,
    datasets: [{
        data: null,
        label: "Orders",
        backgroundColor: "#192D39",
        borderColor: "#009991",
        pointRadius: 8,
    }]
})

const stats = ref(null)
const store = useMonitorStore()
const chart_options = {
    responsive: true
}


const getStats = async () => {
    chart_data.labels = null
    chart_data.datasets[0].data = null
    await store.getOrdersStats()
    stats.value = store.order_stats

    chart_data.labels = stats.value?.graph?.x_axis
    chart_data.datasets[0].data = stats.value?.graph?.data
}

onMounted(async () => {
    await getStats()

    window.Echo.private(`orders`)
        .listen('OrderCreated', async (e) => {
            await getStats()
        })
})

onUnmounted(() => {
    window.Echo.leave(`private-orders`)
})
</script>

<template>
    <div class="monitor-container --stats-monitor-view">
        <monitor-header title="Order stats."/>

        <div class="monitor-overview-container">
            <div class="monitor-overview-container-row">
                <div class="monitor-pill">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="cart-default"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">All orders.</p>
                            <p class="monitor-pill-stat">{{ stats?.orders }}</p>
                        </div>
                    </div>
                </div>
                <div class="monitor-pill">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="calendar-empty"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">Today.</p>
                            <p class="monitor-pill-stat">{{ stats?.today_orders }}</p>
                        </div>
                    </div>
                </div>
                <div class="monitor-pill">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="calendar-range"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">This month.</p>
                            <p class="monitor-pill-stat">{{ stats?.this_month_orders }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="monitor-overview-container-row">
                <div class="monitor-overview-item">
                    <div class="monitor-pill">
                        <div class="monitor-pill-content">
                            <div class="monitor-pill-icon-block">
                                <ah-icon name="check-circle"/>
                            </div>
                            <div class="monitor-pill-info">
                                <p class="monitor-pill-title">Completed.</p>
                                <p class="monitor-pill-stat">{{ stats?.completed_orders }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="monitor-pill">
                        <div class="monitor-pill-content">
                            <div class="monitor-pill-icon-block">
                                <ah-icon name="pending-circle"/>
                            </div>
                            <div class="monitor-pill-info">
                                <p class="monitor-pill-title">Pending.</p>
                                <p class="monitor-pill-stat">{{ stats?.pending_orders?.all }}</p>
                            </div>
                        </div>

                        <div class="monitor-pill-detail">
                            <div class="monitor-pill-detail-pill">
                                <span
                                    class="monitor-pill-detail-pill-value">{{ stats?.pending_orders?.submitted }}</span>

                                <span class="monitor-pill-detail-pill-label">Submitted</span>
                            </div>
                            <div class="monitor-pill-detail-pill">
                                <span
                                    class="monitor-pill-detail-pill-value">{{
                                        stats?.pending_orders?.awaiting_payment
                                    }}</span>

                                <span class="monitor-pill-detail-pill-label">Awaiting Payment</span>
                            </div>
                            <div class="monitor-pill-detail-pill">
                                <span
                                    class="monitor-pill-detail-pill-value">{{
                                        stats?.pending_orders?.awaiting_install
                                    }}</span>

                                <span class="monitor-pill-detail-pill-label">Awaiting Install</span>
                            </div>
                            <div class="monitor-pill-detail-pill">
                                <span class="monitor-pill-detail-pill-value">{{ stats?.pending_orders?.poa }}</span>
                                <span class="monitor-pill-detail-pill-label">POA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="monitor-overview-item" v-if="chart_data.labels">
                    <div class="monitor-overview-item-graph-heading">
                        <p>Total orders per day.</p>
                    </div>
                    <div style="width: 1056px; padding-left: 45px">
                        <Line
                            id="my-chart-id"
                            :options="chart_options"
                            :data="chart_data"
                        />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped lang="scss">
.monitor-overview-item-graph-heading {
    height: 8.9rem;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    padding-left: 5rem;

    p {
        @include font(2.5, 2.5, black);
        color: var(--color-mist);
    }
}
</style>
